package pl.decks.personal.components.animations

import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.StyleVariable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.percent

object SlideLeftRightAnimation {
    object Vars {
        val fromPosition by StyleVariable<CSSLengthOrPercentageNumericValue>(0.percent)
        val toPosition by StyleVariable<CSSLengthOrPercentageNumericValue>(100.percent)
    }

    val Frames = Keyframes {
        from { Modifier.left(Vars.fromPosition.value()) }
        to { Modifier.left(Vars.toPosition.value()) }
    }
}
